angular.module('bmsApp.sm.job')
	.controller('SMMergeVisitsModalCtrl',
		function ($state,
				  $modalInstance,
				  $scope,
				  SMJobSvc,
				  SMScheduleSvc,
				  ConfigService,
				  $filter,
				  EmployeeSvc,
				  $mdDialog,
				  SMScheduleSvc,
				  visitId) {


			function init() {
				$scope.config = ConfigService.config;
				$scope.datePickerConfig = angular.extend(angular.copy($scope.config.datePicker.basic), {
					options: angular.extend(angular.copy($scope.config.datePicker.basic.options), {
						parentEl: '.modal-content'
					})
				});

				$scope.timePickerConfig = angular.extend(angular.copy($scope.config.uiTimepickerOptions), {
					appendTo: '.modal-content'
				});



				self.job = visit.job;
				self.visits = $filter('filter')(self.job.visits, {visit_date: visit.visit_date}, function (actual, expected) {
					var expectedDate = moment(expected, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
					var actualDate = moment(actual, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
					return actualDate == expectedDate;
				});

			}

			function cancel() {
				$modalInstance.dismiss('cancel');
			}

			function submit() {
				SMScheduleSvc.mergeVisits({visits: self.visits}).then(function(response) {
					$modalInstance.close(response);
				});
			}

			var self = $scope.SMMergeVisitsCtrl = {
				loading: true,
				job: {},
				methods: {
					init: init,
					cancel: cancel,
					submit: submit
				}
			}

		});
